module.exports = __webpack_public_path__ + "static/media/why_tr.38f8ee21.vtt";